import { render, staticRenderFns } from "./collection_assignments.vue?vue&type=template&id=880c4604&"
import script from "./collection_assignments.vue?vue&type=script&lang=js&"
export * from "./collection_assignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports